import React, { useState } from 'react'

import { AppSetting, MenuItem } from '../../screens/App/App'
import SearchComponent from '../../shared/components/SearchComponent'
import NavBar from './Navbar'
import { useHistory } from 'react-router-dom'
import { Box, IconButton, Theme, useMediaQuery, useTheme } from '@mui/material'
import PersonIcon from '@mui/icons-material/Person'
import LogoutIcon from '@mui/icons-material/Logout'
import { useDispatch, useSelector } from 'react-redux'
import * as settingsActions from '../../store/settings/settings.actions'
import { getNavPoint } from '../../store/settings/settings.selectors'

interface Props {
  items: AppSetting[]
  user?: any
  onLogout: () => void
  changeSearch?: (value?: string) => void
}

const HeaderComponent: React.FC<Props> = (props) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const navPoint: string[] = useSelector(getNavPoint)
  const theme: Theme = useTheme()
  const downXs = useMediaQuery(theme.breakpoints.down('xs'))
  const downSm = useMediaQuery(theme.breakpoints.down('sm'))
  const downMd = useMediaQuery(theme.breakpoints.down('md'))
  const downLg = useMediaQuery(theme.breakpoints.down('lg'))

  const [tab, setTab] = useState<AppSetting | undefined>(props.items.find(elem => elem.value === navPoint[0]))
  const [activeUserProfile, setActiveUserProfile] = useState<boolean>(false)
  const [searchValue, setSearchValue] = useState<string>('')

  const changeTab = (value: MenuItem) => {
    setSearchValue('')
    setActiveUserProfile(false)
    const newTab = props.items.find(elem => elem.value === value) || props.items[0]
    setTab(newTab)
    dispatch(settingsActions.setNavPoint([value]))
    history.replace(newTab.path)
  }

  const top: string = downXs ? '-5vh' : (downSm ? '-10vh' : (downMd ? '-15vh' : (downLg ? '-20vh' : '-30vh')))
  const height: string = downXs ? '15vh' : (downSm ? '25vh' : (downMd ? '30vh' : (downLg ? '40vh' : '50vh')))
  return (
    <>
      <Box sx={{ position: 'relative', height: height, overflow: 'hidden' }}>
        <Box sx={{ position: 'absolute', top: top, width: '100%' }}>
          <img
            src='/images/header.jpg'
            style={{ width: '100%', filter: 'brightness(40%)' }}
          />
        </Box>
      </Box>
      <NavBar items={props.items} changeTab={changeTab} selectedTab={tab} />
      <IconButton
        onClick={() => {
          setSearchValue('')
          setTab(undefined)
          setActiveUserProfile(true)
          dispatch(settingsActions.setNavPoint(['userProfile']))
          history.replace('/' + MenuItem.userProfile)
        }}
        sx={{
          position: 'absolute',
          display: 'flex',
          top: 8,
          right: 50,
          padding: '20px 0',
          color: activeUserProfile ? theme.palette.primary.main : '#fff',
        }}
      ><PersonIcon />
      </IconButton>
      <IconButton
        onClick={() => {
          props.onLogout()
        }}
        sx={{
          position: 'absolute',
          display: 'flex',
          top: 8,
          right: 20,
          padding: '20px  0',
          color: '#fff',
        }}
      ><LogoutIcon />
      </IconButton>
      <SearchComponent
        value={searchValue}
        changeSearch={(value?: string) => props.changeSearch && props.changeSearch(value)}
      />
    </>
  )
}

export default HeaderComponent
